// extracted by mini-css-extract-plugin
export default {"round":"_1yBGhr_T9-IDFYeyn_wtbp"};